var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssuiGlaceRepare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#221e23;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 essui glace r\xE9par\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1694,1370.91c23-9.37,36.82-14.68,52-18.26S1874,1340,1874,1340s7.22-8.39,16.32-10.86,145.31-17,153.62-9.85c-1.19,14.4-.94,10.71-.94,10.71s87.17-7.42,99.09-8,69.33-6,85.91-6c5,16,1,16,1,16s-30-1-51,3c-21.32.36-154.72,15.43-187,18C1933.9,1357.54,1724.18,1369.56,1694,1370.91Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssuiGlaceRepare);
export default __webpack_public_path__ + "static/media/essui_glace_repare.8ce543106f81e5a53a1898d028e2d04b.svg";
export { ForwardRef as ReactComponent };